import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook,
  faBars,
  faBuilding,
  faCalendar,
  faCheck,
  faChevronDown,
  faChevronRight,
  faClipboardListCheck,
  faClockRotateLeft,
  faCog,
  faColumns3,
  faEllipsisVertical,
  faEnvelope,
  faFileArrowDown,
  faFileCsv,
  faFileImport,
  faFloppyDisk,
  faFolder,
  faFolders,
  faGlobe,
  faGripDotsVertical,
  faGripLines,
  faLayerGroup,
  faLinkHorizontal,
  faLinkHorizontalSlash,
  faListTimeline,
  faLocationPin,
  faMagnifyingGlass,
  faMapLocationDot,
  faMemoCircleInfo,
  faPaperPlane,
  faPencil,
  faPhone,
  faPlus,
  faRepeat,
  faReplyClock,
  faRotateLeft,
  faSitemap,
  faStarChristmas,
  faSubtitles,
  faTimelineArrow,
  faTrash,
  faTreePalm,
  faUser,
  faUserCrown,
  faUsers,
  faUserSlash,
  faVirus,
  faWrench,
  faXmark
} from '@fortawesome/pro-light-svg-icons'

import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons'

export const icons = [
  faBars,
  faBuilding,
  faCalendar,
  faCheck,
  faChevronDown,
  faChevronRight,
  faClipboardListCheck,
  faClockRotateLeft,
  faCog,
  faColumns3,
  faCircleExclamation,
  faEllipsisVertical,
  faEnvelope,
  faFileArrowDown,
  faFileCsv,
  faFloppyDisk,
  faFolder,
  faFolders,
  faGlobe,
  faGripDotsVertical,
  faGripLines,
  faLayerGroup,
  faLinkHorizontal,
  faLinkHorizontalSlash,
  faListTimeline,
  faLocationPin,
  faMagnifyingGlass,
  faMemoCircleInfo,
  faPaperPlane,
  faPencil,
  faPhone,
  faPlus,
  faRepeat,
  faReplyClock,
  faTimelineArrow,
  faFileImport,
  faRotateLeft,
  faSitemap,
  faSubtitles,
  faTrash,
  faTreePalm,
  faTimelineArrow,
  faUser,
  faUserCrown,
  faUsers,
  faUserSlash,
  faVirus,
  faWrench,
  faXmark,
  faMapLocationDot,
  faAddressBook,
  faStarChristmas
]

library.add(...icons)
